module.exports = __webpack_public_path__ + "img/resized-APP-0017-1.db5efec0.png";